import React from 'react';
import Banner from '../Banner/Banner';
import { isMobile } from '../../utils/browser';
import { connect } from 'react-redux';
import { QueryFunctionContext, useQuery } from 'react-query';
import { fetchServiceArea } from '../../api/configs';
import { City, Location } from '../../api/models/locations';
import { ServiceAreaConfig } from '../../api/models/configs';
import styles from './NotificationBar.module.less';

type NotificationBarProps = {
  selectedPickupLocation?: Location;
  cities: City[];
};

const fetchServiceAreaRequest = ({ queryKey }: QueryFunctionContext<any, any>) => {
  const [, cities] = queryKey;
  return fetchServiceArea(cities);
};

export const NotificationBar = (props: NotificationBarProps) => {
  const { selectedPickupLocation, cities } = props;
  const { data } = useQuery<ServiceAreaConfig[]>(
    ['fetchServiceArea', cities.map(city => city.serviceAreaId).filter(Boolean)],
    fetchServiceAreaRequest,
    {
      // The query will not execute until the cities fetched
      enabled: Boolean(cities.length)
    }
  );
  const serviceAreaId =
    selectedPickupLocation?.city && cities.find(city => city.name === selectedPickupLocation.city)?.serviceAreaId;
  const text = data?.find(serviceAreaConfig => serviceAreaConfig.serviceAreaId === serviceAreaId)?.bannerText;
  if (!text) {
    return null;
  }
  return <Banner type={'warning'} message={text} closable={isMobile()} className={styles.banner} />;
};

const mapState = ({
  user: { selectedPickupLocation, cities }
}: {
  user: { selectedPickupLocation: Location; cities: City[] };
}) => ({
  selectedPickupLocation,
  cities
});

export default connect(mapState)(NotificationBar);
